"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLoanByIdQuery = exports.useGetUserLoansQuery = exports.loansApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.loansApi = (0, react_1.createApi)({
    reducerPath: "loansApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL || "http://localhost:7002"),
    tagTypes: ["Loans"],
    endpoints: function (builder) { return ({
        getUserLoans: builder.query({
            query: function () { return ({
                url: "/v1/loans/user-loans",
                method: "GET",
            }); },
            providesTags: ["Loans"],
        }),
        getLoanById: builder.query({
            query: function (loanId) { return ({
                url: "/v1/loans/loan/".concat(loanId),
                method: "GET",
            }); },
            providesTags: function (result, error, loanId) { return [{ type: "Loans", id: loanId }]; },
        }),
    }); },
});
exports.useGetUserLoansQuery = exports.loansApi.useGetUserLoansQuery, exports.useGetLoanByIdQuery = exports.loansApi.useGetLoanByIdQuery;
